import { render, staticRenderFns } from "./StartDemoProcess.vue?vue&type=template&id=14c7f6f4&lang=pug"
import script from "./StartDemoProcess.vue?vue&type=script&lang=js"
export * from "./StartDemoProcess.vue?vue&type=script&lang=js"
import style0 from "./StartDemoProcess.vue?vue&type=style&index=0&id=14c7f6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports